import { IconMenu2 } from "@tabler/icons-react";
import cx from "classnames";
import Router, { useRouter } from "next/router";
import { CompanyLayout } from "pages/[company]/_layout";
import pages from "pages/_router";
import React, { CSSProperties } from "react";
import { api } from "shared/api";
import { Button } from "shared/ui";
import styles from "./_layout.module.scss";

export interface IFinancesEducationLayout {
  step?: number;
  title?: React.ReactNode;

  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FinancesEducationLayout = (props: IFinancesEducationLayout) => {
  const companySlug = useRouter().query.company as string;
  const educationRouter = pages.company(companySlug).finances.education;

  const financeSettings = api.financeSettings.useFinanceSettingsGet(companySlug);

  const onSkip = async () => {
    await api.financeSettings.financeSettingsUpdateEducation(companySlug, { education: false });
    await financeSettings.mutate();

    await Router.push(pages.company(companySlug).finances.href);
  };

  return (
    <CompanyLayout
      title="Знакомство с модулем «Финансы»"
      actions={
        <Button type="secondary" onClick={onSkip}>
          Пропустить обучение
        </Button>
      }
      className={cx(styles._layout, props.className)}
      style={props.style}
      htmlId={props.htmlId}
    >
      {props.step && (
        <div className={styles.header}>
          <Button type="secondary" onClick={() => Router.push(educationRouter.tableOfContent.href)}>
            <IconMenu2 size={20} stroke={1.5} /> Оглавление
          </Button>

          <div>{props.step} / 15</div>

          <div>{props.title}</div>
        </div>
      )}

      {props.children}
    </CompanyLayout>
  );
};

FinancesEducationLayout.defaultProps = {};
